import { MenuHeader } from "../others/MenuHeader";
import { AuthToken } from "../request/AuthToken";
import { ResponseBody } from "./ResponseBody"
export class LoginResponse extends ResponseBody{
      name:string
      passwordreset:string
      role: string
      menus: MenuHeader[];
      personId:string;
      authToken:AuthToken;
}